<div style="
    min-height: 100vh !important;
    height: 100vh;
    overflow: hidden;
    display: flex !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, sans-serif !important;
    line-height: 1.6 !important;
    color: #334155 !important;
  ">

  <!-- <a routerLink="/landingPage" style="text-align: left !important;color: #00adee !important;text-decoration: none !important; position: absolute; top:7%; left:7%;
display: block !important;
margin-bottom: 0.75rem !important;">
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"/>
</svg>
</a> -->
  <button class="back-arrow" (click)="goBack()" title="Back to Home" style="text-decoration: none !important; position: absolute; top:7%; left:7%;
display: block !important;
margin-bottom: 0.75rem !important;">
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
     <span class="back-arrow-text">Back to Home</span>
  </button>
  <!-- Left Side - Welcome Panel -->
  <div class="d-none d-lg-flex class1 d-flex align-items-center justify-content-center">

    <div style="max-width: 20rem !important; text-align: center !important">
      <div style="margin-bottom: 2rem !important">
        <img src="../../../assets/img/logo1.png" alt="KEMIS - Kenya Education Management Information System" style="
            height: auto !important;
            max-width: 8rem !important;
          " routerLink="/landingPage" />
        <!-- style="
            width: 100% !important;
            height: auto !important;
            max-width: 20rem !important;
          " -->
      </div>
      <div style="margin-bottom: 2rem !important">
        <h1 style="
            font-size: 1.5rem !important;
            font-weight: 700 !important;
            color: #1e293b !important;
            margin-bottom: 1rem !important;
          ">
          Welcome Back
        </h1>
        <p style="color: #475569 !important">
          Access your education management portal to streamline learning and
          administrative processes.
        </p>
      </div>
      <div style="padding-top: 2rem !important">
        <p style="
            font-size: 0.875rem !important;
            color: #64748b !important;
            margin-bottom: 0.25rem !important;
          ">
          Ministry of Education
        </p>
        <p style="font-size: 0.75rem !important; color: #94a3b8 !important">
          Republic of Kenya
        </p>
      </div>
    </div>
  </div>

  <!-- Right Side - Login Form -->
  <div class="class2 d-flex align-items-center justify-content-center">
    <div style="
        width: 100% !important;
        max-width: 28rem !important;
        position: relative !important;
        z-index: 10 !important;
      ">
      <!-- Mobile Logo -->
      <div style="margin-bottom: 2rem !important; text-align: center !important" class="d-lg-none">
        <img src="../../../assets/img/logo1.png" alt="KEMIS Logo"
          style="height: 4rem !important; width: auto !important" />
      </div>

      <!-- Login Card -->
      <div style="
          background: rgba(255, 255, 255, 0.95) !important;
          backdrop-filter: blur(8px) !important;
          border-radius: 0.5rem !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          border: none !important;
        ">
        <div style="
            text-align: center !important;
            padding: 1.5rem 1.5rem 1rem !important;
            background: transparent !important;
          ">
          <h2 style="
              font-size: 1.5rem !important;
              font-weight: 700 !important;
              color: #1e293b !important;
              margin-bottom: 0.5rem !important;
            ">
            Login
          </h2>
          <p style="color: #475569 !important; margin-bottom: 0 !important">
            Enter your credentials to continue
          </p>
        </div>

        <div style="padding: 1.5rem !important">
          <form id="loginForm" class="login-form" [formGroup]="loginForm" (keydown.enter)="registerUser()">
            <!-- Email Field -->
            <div style="margin-bottom: 1.25rem !important">
              <label for="email" style="
                  font-size: 0.875rem !important;
                  font-weight: 500 !important;
                  color: #374151 !important;
                  margin-bottom: 0.5rem !important;
                  display: block !important;
                ">Email ID</label>
              <div style="position: relative !important; display: flex !important">
                <span style="
                    display: flex !important;
                    align-items: center !important;
                    padding: 0 0.75rem !important;
                    background: white !important;
                    border: 1px solid #d1d5db !important;
                    border-right: none !important;
                    color: #9ca3af !important;
                  ">
                  <i class="fas fa-envelope"></i>
                </span>
                <input type="email" id="email" placeholder="Enter your email" required formControlName="userName"
                  onkeypress="return !(event.charCode === 32 || this.selectionStart === 0)" style="
                    flex: 1 !important;
                    height: 3rem !important;
                    border: 1px solid #d1d5db !important;
                    border-left: none !important;
                    background: white !important;
                    font-size: 0.875rem !important;
                    padding: 0 0.75rem !important;
                  " />
              </div>
            </div>

            <!-- Password Field -->
            <div style="margin-bottom: 1.25rem !important">
              <label for="password" style="
                  font-size: 0.875rem !important;
                  font-weight: 500 !important;
                  color: #374151 !important;
                  margin-bottom: 0.5rem !important;
                  display: block !important;
                ">Password</label>
              <div style="position: relative !important; display: flex !important">
                <span style="
                    display: flex !important;
                    align-items: center !important;
                    padding: 0 0.75rem !important;
                    background: white !important;
                    border: 1px solid #d1d5db !important;
                    border-right: none !important;
                    color: #9ca3af !important;
                  ">
                  <i class="fas fa-lock"></i>
                </span>
                <input type="password" id="password" placeholder="Enter your password" formControlName="password"
                  [type]="fieldTextType ? 'text' : 'password'" required style="
                    flex: 1 !important;
                    height: 3rem !important;
                    border: 1px solid #d1d5db !important;
                    border-left: none !important;
                    background: white !important;
                    font-size: 0.875rem !important;
                    padding: 0 0.75rem !important;
                  " />
                <button type="button" id="togglePassword" style="
                    border-left: none !important;
                    background: white !important;
                    border: 1px solid #d1d5db !important;
                    color: #9ca3af !important;
                    padding: 0 0.75rem !important;
                  ">
                  <i class="fas fa-eye" id="toggleIcon" [ngClass]="{
                      'fa-eye-slash': !fieldTextType,
                      'fa-eye': fieldTextType
                    }" (click)="toggleFieldTextType()"></i>
                </button>
              </div>
            </div>
            <!-- 2 factor authnitcation -->
            <div style="margin-bottom: 1.25rem !important" *ngIf="showAuthCode">
              <label for="email" style="
                  font-size: 0.875rem !important;
                  font-weight: 500 !important;
                  color: #374151 !important;
                  margin-bottom: 0.5rem !important;
                  display: block !important;
                ">Auth Code</label>
              <div style="position: relative !important; display: flex !important">
                <span style="
                    display: flex !important;
                    align-items: center !important;
                    padding: 0 0.75rem !important;
                    background: white !important;
                    border: 1px solid #d1d5db !important;
                    border-right: none !important;
                    color: #9ca3af !important;
                  ">
                  <i class="fas fa-user-secret"></i>
                </span>
                <input type="code" id="code" placeholder="Enter your code" required formControlName="login_autogen_code"
                  onkeypress="return !(event.charCode === 32 || this.selectionStart === 0)" style="
                    flex: 1 !important;
                    height: 3rem !important;
                    border: 1px solid #d1d5db !important;
                    border-left: none !important;
                    background: #e8f0fe !important;
                    font-size: 0.875rem !important;
                    padding: 0 0.75rem !important;
                  " />
              </div>
            </div>



            <!-- Remember Me & Forgot Password -->
            <div style="
                display: flex !important;
                justify-content: space-between !important;
                align-items: center !important;
                margin-bottom: 1.25rem !important;
                font-size: 0.875rem !important;
              ">
              <div>
                <input type="checkbox" id="rememberMe" style="margin-right: 0.5rem !important" />
                <label for="rememberMe" style="color: #475569 !important; cursor: pointer !important">Remember
                  me</label>
              </div>
              <a href="javascript:" style="
                  color: #00adee !important;
                  text-decoration: none !important;
                " data-bs-toggle="modal" data-bs-target="#exampleModal">Forgot password?</a>
            </div>

            <!-- Login Button -->
            <button (click)="registerUser()" type="submit" style="
                width: 100% !important;
                height: 3rem !important;
                background-color: #00adee !important;
                border: 1px solid #00adee !important;
                font-weight: 500 !important;
                font-size: 0.875rem !important;
                color: white !important;
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
                cursor: pointer !important;
              ">
              Login
            </button>
          </form>

          <!-- Additional Links -->
          <div style="
              text-align: center !important;
              padding-top: 1rem !important;
              border-top: 1px solid #e5e7eb !important;
              margin-top: 1.5rem !important;
            ">
            <a href="javascript:" style="
                color: #00adee !important;
                text-decoration: none !important;
                font-size: 0.875rem !important;
                display: block !important;
                margin-bottom: 0.75rem !important;
              " (click)="gotoSchoolRegister()">Institution Onboarding</a>

            <div style="font-size: 0.875rem !important; color: #475569 !important">
              Need help?
              <a href="#" style="
                  color: #00adee !important;
                  text-decoration: none !important;
                  font-weight: 500 !important;
                ">Contact Support</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Footer -->
      <div style="
          margin-top: 1.5rem !important;
          text-align: center !important;
          font-size: 0.75rem !important;
          color: #475569 !important;
        " class="d-lg-none">
        <p>© 2024 Ministry of Education, Republic of Kenya</p>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Forgot Password</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="row mb-2" style="align-items: center !important">
              <div class="col-md-3">
                Email Id
                <span class="text-danger" style="font-size: 20px !important">* </span>:
              </div>
              <div class="col-md-9 pt-2">
                <input type="email" class="form-control" (blur)="validateEmail($event)" [(ngModel)]="emailId"
                  [ngModelOptions]="{ standalone: true }"
                  onkeypress="return !(event.charCode === 32 || this.selectionStart === 0)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" id="md_close" (click)="close()" data-bs-dismiss="modal">
          Close
        </button>
        <button type="button" class="btn btn-save" (click)="onForgotPasswordClick()">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>